import { createFileRoute } from '@tanstack/react-router';
import { useAdminAuthGuard } from '@/features/admin/hooks';
import { PublishTermsCard } from '@/features/admin/PublishTermsCard';
import { AdminShell } from '@/features/admin/components/AdminShell';
import { AdminPageHeader } from '@/features/admin/components/AdminPageHeader';
import { AdminLogoutButton } from '@/features/admin/components/AdminLogoutButton';

/**
 * Admin Terms route — the primary admin task. Renders the Terms manager
 * (PublishTermsCard) full-width inside AdminShell. Now that it owns the whole
 * page the side-by-side editor + production preview have room to breathe.
 *
 * Bounces to /admin/login if the admin cookie isn't set (same guard as the
 * dashboard, via useAdminAuthGuard).
 */
export const Route = createFileRoute('/admin/terms')({
  component: AdminTermsPage,
});

function AdminTermsPage() {
  useAdminAuthGuard();

  return (
    <AdminShell actions={<AdminLogoutButton />}>
      <AdminPageHeader
        title="Terms & Conditions"
        subtitle="Each document is versioned independently — its version and last-updated date are shown per row."
      />
      <div className="bg-white border border-line rounded-xl shadow-card p-6 sm:p-7 min-w-0">
        <PublishTermsCard />
      </div>
    </AdminShell>
  );
}
